/**
 * Radeway — Boost SD Custom JS v4
 * 2026-04-02
 *
 * Self-contained star rating injection for Boost SD collection pages.
 * Does NOT depend on Loox widget JS loading first.
 * Uses loox_global_hash (available in page source) and Loox ratings API directly.
 */
(function() {
  var path = window.location.pathname;
  if (path.indexOf('/collections/') === -1 && path.indexOf('/search') === -1) return;

  var CLIENT_ID = 'E1Wnl8TZSi';
  var HASH = window.loox_global_hash || '';
  var STAR_COLOR = '#EBBF20';
  var EMPTY_COLOR = '#D8D8D8';
  var ratingsCache = {};
  var handleToId = {};
  var running = false;

  // Build handle->id map from boostSDFallback
  function buildHandleMap() {
    var products = [];
    try { products = window.boostSDFallback.products || []; } catch(e) {}
    products.forEach(function(p) {
      if (p.handle && p.id) handleToId[p.handle] = String(p.id);
    });
  }

  function starSVG(fill) {
    return '<svg width="14" height="14" viewBox="0 0 24 24" style="vertical-align:middle;"><path fill="' + fill + '" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/></svg>';
  }

  function halfStarSVG(uid) {
    return '<svg width="14" height="14" viewBox="0 0 24 24" style="vertical-align:middle;"><defs><linearGradient id="rdwh' + uid + '"><stop offset="50%" stop-color="' + STAR_COLOR + '"/><stop offset="50%" stop-color="' + EMPTY_COLOR + '"/></linearGradient></defs><path fill="url(#rdwh' + uid + ')" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/></svg>';
  }

  function renderStarsHTML(rating, raters) {
    var full = Math.floor(rating);
    var hasHalf = (rating - full) >= 0.25;
    var html = '<div style="display:inline-flex;align-items:center;gap:1px;flex-wrap:nowrap;">';
    for (var i = 0; i < 5; i++) {
      if (i < full) html += starSVG(STAR_COLOR);
      else if (i === full && hasHalf) html += halfStarSVG(Math.random().toString(36).substr(2,5));
      else html += starSVG(EMPTY_COLOR);
    }
    html += ' <span style="font-size:12px;color:#555;margin-left:3px;">(' + raters + ')</span></div>';
    return html;
  }

  function fetchRatings(ids, callback) {
    if (!ids.length) return;
    if (!HASH) HASH = window.loox_global_hash || '';
    if (!HASH) return;
    
    var url = 'https://loox.io/widget/' + CLIENT_ID + '/ratings?products_ids=' + ids.join(',') + '&h=' + HASH;
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.onload = function() {
      try {
        var resp = JSON.parse(xhr.responseText);
        if (resp.success && Array.isArray(resp.ratings)) {
          resp.ratings.forEach(function(r) {
            ratingsCache[String(r.pid)] = { rating: r.rating, raters: r.raters };
          });
          if (callback) callback();
        }
      } catch(e) {}
    };
    xhr.send();
  }

  function process() {
    if (running) return;
    running = true;

    buildHandleMap();

    // Find ALL links to products inside the collection content area
    var container = document.getElementById('boost-sd') ||
                    document.querySelector('[class*="boost-sd"]') ||
                    document.getElementById('main-content') ||
                    document.getElementById('MainContent') ||
                    document.querySelector('main') ||
                    document.body;

    var links = container.querySelectorAll('a[href*="/products/"]:not([data-rdw-rated])');
    if (!links.length) { running = false; return; }

    var needFetch = [];
    var linkMap = {}; // pid -> [link elements]

    links.forEach(function(link) {
      link.setAttribute('data-rdw-rated', '1');
      var href = link.getAttribute('href') || '';
      var m = href.match(/\/products\/([^?&#\/]+)/);
      if (!m) return;
      var handle = m[1];
      var pid = handleToId[handle];
      if (!pid) return;

      // Find the product card container (walk up max 5 levels)
      var card = link;
      for (var i = 0; i < 5; i++) {
        if (!card.parentElement) break;
        card = card.parentElement;
        // Stop if we hit a recognizable product card boundary
        var cls = card.className || '';
        if (cls.indexOf('product') !== -1 || cls.indexOf('item') !== -1 || cls.indexOf('card') !== -1) break;
      }

      // Check if this card already has a rating widget
      if (card.querySelector('[data-rdw-stars]')) return;

      // Find where to insert: after title-like element, or after the link itself
      var anchor = card.querySelector('h2, h3, h4, [class*="title"], [class*="name"]') || link;

      var wrapper = document.createElement('div');
      wrapper.setAttribute('data-rdw-stars', pid);
      wrapper.className = 'loox-rating';
      wrapper.style.cssText = 'margin:4px 0 2px;min-height:18px;line-height:1;';

      // Insert after the anchor
      if (anchor.nextSibling) {
        anchor.parentNode.insertBefore(wrapper, anchor.nextSibling);
      } else {
        anchor.parentNode.appendChild(wrapper);
      }

      if (ratingsCache[pid]) {
        wrapper.innerHTML = renderStarsHTML(ratingsCache[pid].rating, ratingsCache[pid].raters);
      } else {
        if (!linkMap[pid]) { linkMap[pid] = []; needFetch.push(pid); }
        linkMap[pid].push(wrapper);
      }
    });

    if (needFetch.length > 0) {
      var unique = needFetch.filter(function(v,i,a){ return a.indexOf(v)===i; });
      fetchRatings(unique, function() {
        unique.forEach(function(pid) {
          var data = ratingsCache[pid];
          if (!data || data.rating <= 0) return;
          var wrappers = document.querySelectorAll('[data-rdw-stars="' + pid + '"]');
          wrappers.forEach(function(w) {
            w.innerHTML = renderStarsHTML(data.rating, data.raters);
          });
        });
      });
    }

    running = false;
  }

  // Watch for DOM changes
  var debounce = null;
  var observer = new MutationObserver(function() {
    clearTimeout(debounce);
    debounce = setTimeout(process, 400);
  });

  function start() {
    var target = document.getElementById('boost-sd') ||
                 document.getElementById('main-content') ||
                 document.getElementById('MainContent') ||
                 document.querySelector('main') ||
                 document.body;
    observer.observe(target, { childList: true, subtree: true });

    // Multiple retries
    [500, 1500, 3000, 5000, 8000, 12000, 18000, 25000].forEach(function(ms) {
      setTimeout(process, ms);
    });

    // Stop observing after 35s
    setTimeout(function() { observer.disconnect(); }, 35000);
  }

  // Boost SD events
  document.addEventListener('boost-sd:product-list-rendered', process);
  document.addEventListener('boost-sd:page-rendered', process);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
